<template>
  <div class="rent_wrapper" v-if="canEdit || canDelete" v-cloak>
    <card :title="$t('common.contracts')" id="contracts">
      <div class="content-body pt-4">
        <div class="row">
          <div class="col-lg-12">
            <DxDataGrid
              :ref="contractGridRefKey"
              :data-source="contractDataSurce"
              :show-borders="false"
              :remote-operations="gridRemoteOperations"
              :element-attr="gridAttributes"
            >
              <DxColumn data-field="contract_number" data-type="string" caption="Numar contract" />
              <DxColumn data-field="owner" data-type="string" caption="Proprietar" />
              <DxColumn data-field="start_date" data-type="string" caption="Data inceput">
                <DxFormat type="shortDate" :formatter="formatDate" />
              </DxColumn>
              <DxColumn data-field="end_date" data-type="string" caption="Data sfarsit">
                <DxFormat type="shortDate" :formatter="formatDate" />
              </DxColumn>

              <DxPaging :total="3500" :page-size="15" />
              <DxPager
                :visible="true"
                :allowed-page-sizes="pageSizes"
                display-mode="compact"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="true"
                :info-text="$t('common.page_info')"
              />
              <DxEditing :allow-adding="false" :allow-updating="false" :allow-deleting="false" :use-icons="true" mode="row" />
              <DxHeaderFilter :visible="true" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxSelection mode="single" />
              <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
              <template #masterDetailTemplate="{ data: contractData }">
                <ContractItems :templateData="contractData" />
              </template>
            </DxDataGrid>
          </div>
        </div>
      </div>
    </card>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxEditing,
  DxStringLengthRule,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxMasterDetail,
  DxFormat,
} from "devextreme-vue/data-grid";
import Forbidden from "@/pages/errors/Forbidden.vue";
import { canDelete, canEdit, permissions, permissionTypes } from "@/helpers/Permissions";
import CustomStore from "devextreme/data/custom_store";
import ContractItems from "./contractItems.vue";
import { getFilterDataByName, getSortByProperty, getSortDirection } from "@/helpers/dxGridHelper";

export default {
  name: "ContractAdminList",
  middleware: ["auth", "check-company-admin"],
  data() {
    return {
      gridAttributes: {
        class: "admin-grid",
      },
      contractGridRefKey: "contract-grid",
      gridRemoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
      pageSizes: [15, 25, 100],
      contractDataSurce: new CustomStore({
        key: "uuid",
        load: this.loadContracts,
        insert: this.insert,
        update: this.update,
        remove: this.delete,
      }),
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxEditing,
    DxStringLengthRule,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxMasterDetail,
    DxFormat,
    ContractItems,
  },
  computed: {
    canEdit() {
      return canEdit(this);
    },
  },
  methods: {
    ...mapActions({
      getContracts: "leasecontracts/getContracts",
    }),
    formatDate(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();

      month = ("0" + month).slice(-2);
      day = ("0" + day).slice(-2);

      return `${year}-${month}-${day}`;
    },
    async loadContracts(loadOptions) {
      let pageLimit = loadOptions.take;
      let pageNumber = (loadOptions.skip + loadOptions.take) / pageLimit;

      let dataSource = {
        data: [],
        totalCount: 0,
      };
      let payload = {
        page: pageNumber,
        limit: pageLimit,
        sortBy:
          getSortByProperty(loadOptions, [
            { field: "start_date", sortField: "contract_date_from" },
            { field: "end_date", sortField: "contract_date_to" },
          ]) ?? "createdAt",
        sortDirection: getSortDirection(loadOptions) ?? "DESC",
        contract_number: getFilterDataByName(loadOptions, "contract_number"),
        owner_name: getFilterDataByName(loadOptions, "owner"),
        contract_date_from: getFilterDataByName(loadOptions, "start_date"),
        contract_date_to: getFilterDataByName(loadOptions, "end_date"),
      };
      await this.getContracts(payload).then((response) => {
        dataSource.data = response.data;
        dataSource.totalCount = response.pagination.total;
      });

      return dataSource;
    },
    insert(obj) {},
    update(key, obj) {},
    delete(key) {},
  },
};
</script>
